import { Component, OnInit } from '@angular/core';
import { LoginService } from 'app/login/services/login.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CommonService } from 'app/shared/services/common.service';

@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.scss']
})
export class CouponsComponent implements OnInit {

  showAccountSettings=true
  constructor(private localizationService: LocalizationService, private loginService: LoginService,private commonService: CommonService) { }

  ngOnInit(): void {
    this.commonService.changeCurrentPageHeader(this.localizationService.Translate('PROFILE.TITLE')) ;
  }
  ngOnDestroy() {
    this.commonService.clearCurrentPageHeader();
  }
}
